import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FormMAsterService extends BaseService {
  constructor(http: HttpClient, auth: authenticationService) {
    const baseUrl = environment.apiUrl + 'FormsMaster';

    super(http, auth, baseUrl);
  }
}
